// Capture immediately before applying refreshed data, so scrolling during the
// network request remains under the user's control.
export function preserveQueryPosition(host) {
  if (!host) return;
  const focused = document.activeElement;
  const visible = (node) => !node.closest("[hidden]") && node.getBoundingClientRect().bottom > 150;
  const anchor = (focused && host.contains(focused) && visible(focused) ? focused : null)
    || Array.from(host.querySelectorAll(".question-timeline-entry, .query-response-review__card, .question-query-thread__heading"))
      .find((node) => visible(node) && node.getBoundingClientRect().top >= 150)
    || Array.from(host.querySelectorAll(".question-query-thread")).find(visible) || host;
  const top = anchor.getBoundingClientRect().top;
  const containers = [];
  for (let node = host; node; node = node.parentElement) {
    if (node.scrollHeight > node.clientHeight) containers.push({ node, top: node.scrollTop, left: node.scrollLeft });
  }
  const x = window.scrollX, y = window.scrollY;
  requestAnimationFrame(() => {
    if (!anchor.isConnected) return;
    containers.forEach(({ node, top, left }) => { node.scrollTop = top; node.scrollLeft = left; });
    const shift = anchor.getBoundingClientRect().top - top;
    const scroller = containers.find(({ node }) => node !== document.body && node !== document.documentElement);
    if (scroller) scroller.node.scrollTop += shift;
    else if (shift || window.scrollY !== y || window.scrollX !== x) window.scrollTo(x, y + shift);
  });
}
